module.exports = __webpack_public_path__ + "assets/2a880c6366510d36e1265400d9b1be25.mp4";